import React, { useEffect, useState } from "react";
import { getWindowsImages } from "../../services/image_services";
import colors from "../../styles/colors";
import LoadingImage from "../../components/LoadingImage";
import { motion } from "framer-motion";
import WindowType from "../../components/WindowType";
import ProductMain from "../../components/ProductMain";
import Description from "../../components/Description";
import AccessoryContainer from "../../components/AccessoryContainer";
import PortfolioSection from "../../components/HomeSectionContainers/PortfolioSection";
import ContactUsSection from "../../components/HomeSectionContainers/ContactUsSectoin";
import { useTranslation } from "react-i18next";
import SEO from "../../utils/SEO";

const Windows: React.FC = () => {
  const { t } = useTranslation();
  const [images, setImages] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflowX = "hidden";
    return () => {
      document.body.style.overflowX = "auto";
    };
  }, []);

  useEffect(() => {
    const fetchImages = async () => {
      setIsLoading(true);

      try {
        const urls = await getWindowsImages(); // Lokális képlekérdezés
        setImages(urls);
      } catch (error) {
        console.error("Error loading window images:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchImages();
  }, []);

  return (
    <div
      className="flex flex-col items-center justify-center font-serif min-h-screen overflow-hidden"
      style={{ backgroundColor: colors.pastelCream }}
    >
      {isLoading ? (
        <div className="w-full h-screen flex items-center justify-center">
          <LoadingImage />
        </div>
      ) : (
        <ProductMain
          image="/assets/images/products/windows/window_main.webp"
          title={t("windows.title")}
          description={t("windows.subTitle")}
        />
      )}

      {/* SEO meta tags */}
      <SEO
        title={t("seo_meta.windows.metaTitle")}
        description={t("seo_meta.windows.metaDescription")}
      />

      {/* "Description" első rész */}
      {/* Az első Description rész (Kép bal oldalon) */}
      <Description
        image={images[0]}
        title={t("windows.descTitle1")}
        text={t("windows.desc1")}
        imageOnRight={false} // Kép a bal oldalon
        isFirst={true}
      />

      {/* A második Description rész (Kép jobb oldalon) */}
      <Description
        image={images[1]}
        title={t("windows.descTitle2")}
        text={t("windows.desc2")}
        imageOnRight={true} // Kép a jobb oldalon
        isLast={true}
      />

      {/* "Types" Section */}
      <div
        className="w-full h-[70vh] p-4 md:p-8 flex flex-col items-center justify-center text-center space-y-4"
        style={{ backgroundColor: colors.darkBrown }}
      >
        <motion.p
          className="max-w-lg md:text-2xl text-lg font-light text-gray-200"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{
            opacity: 1,
            y: 0,
            transition: { delay: 0.2, duration: 0.5 },
          }}
          viewport={{ once: false, amount: 0.5 }}
        >
          {t("windows.moreInfo")}
        </motion.p>
      </div>

      {/* Wooden Windows Section */}
      <WindowType
        title={t("windows.wooden")}
        subtitle={t("windows.windows")}
        image={images[2]}
        buttonLink="/products/windows/wooden"
        gradientColors={["#403024", "#A47764"]}
      />

      {/* Wood-Aluminium Windows Section with Image on Left */}
      <WindowType
        title={t("windows.wood_alu")}
        subtitle={t("windows.windows")}
        image={images[3]}
        buttonLink="/products/windows/wood-alu"
        gradientColors={["#1E201E", "#405D72"]}
        imageOnRight={false} // image on the left
      />

      {/* Passive Windows Section */}
      {/* <WindowType
        title={t("windows.passive")}
        subtitle={t("windows.windows")}
        image={images[4]}
        buttonLink="/products/windows/passive"
        gradientColors={["#403024", "#DC982D"]}
      /> */}

      <PortfolioSection />

      <AccessoryContainer />

      <ContactUsSection />
    </div>
  );
};

export default Windows;
